import React, { useRef, useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { IMG } from './shared';
import ContactSalesModal from './ContactSalesModal';

// Rentid product suite — each card uses its own pre-designed artwork.
const CARDS = [
  {
    name: 'RentDirect',
    caption: 'No-code, white-labeled, direct-booking engine & rental platform.',
    image: `${IMG}/products/card-rentdirect.png`,
  },
  {
    name: 'rentID',
    caption: 'Instant driver identity verification, license status, MVR, and background check.',
    image: `${IMG}/products/card-rentid.png`,
  },
  {
    name: 'RentShield',
    // Source read "Enbedded insurance and protection servcies API." — typos fixed.
    caption: 'Embedded insurance and protection services API.',
    image: `${IMG}/products/card-rentshield.png`,
  },
  {
    name: 'RentAI',
    caption: 'AI copilot that automates the rental back office, operations, logistics, and admin.',
    image: `${IMG}/products/card-rentai.png`,
  },
  {
    name: 'RentSuccess',
    caption: 'Automated resolution center for rental violations, and claims management.',
    image: `${IMG}/products/card-rentsuccess.png`,
  },
  {
    name: 'RentAcademy',
    caption: 'Training and certification to level up your whole team.',
    image: `${IMG}/products/card-rentacademy.png`,
  },
];

const PROMOS = [
  {
    title: 'Build a Platform.',
    body: 'Create a rental platform of your own with our enterprise tools, workflows, and APIs, for established businesses and rental start ups.',
    linkLabel: 'Contact sales',
    accent: `${IMG}/promo-gradient-teal.png`,
  },
  {
    title: 'Partner Exchange.',
    body: 'Partner with us to reach thousands of operators, renters, and drivers across the industry.',
    linkLabel: 'Become a partner',
    accent: `${IMG}/promo-gradient-green.png`,
  },
];

/** Product suite carousel plus the two enterprise promo cards. */
const ApiIntegration = () => {
  const scrollerRef = useRef(null);
  const [salesOpen, setSalesOpen] = useState(false);

  const scroll = (direction) => {
    const el = scrollerRef.current;
    if (!el) return;
    const amount = el.clientWidth * 0.8;
    el.scrollBy({ left: direction === 'next' ? amount : -amount, behavior: 'smooth' });
  };

  return (
    <section aria-labelledby="api-integration-heading" className="ilp-api">
      <div className="ilp-api-inner">
        <p className="ilp-eyebrow ilp-api-eyebrow">Modern rental platform</p>

        <div className="ilp-api-head">
          <div>
            <h2 id="api-integration-heading" className="ilp-api-title">
              Rental platform with your insurance policy built in.
            </h2>

            {/* The v0 source set a near-black background with black text,
                leaving this CTA unreadable; inverted to white text here. */}
            <button type="button" className="ilp-api-cta" onClick={() => setSalesOpen(true)}>
              Contact Sales
            </button>
          </div>

          <div className="ilp-api-headright">
            <p className="ilp-api-sub">
              Everything you&apos;ll ever need to run, manage, and grow a modern rental business, all
              in one place.
            </p>

            <div className="ilp-api-controls">
              <button type="button" onClick={() => scroll('prev')} aria-label="Previous products">
                <ArrowLeft aria-hidden="true" />
              </button>
              <button type="button" onClick={() => scroll('next')} aria-label="Next products">
                <ArrowRight aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>

        <div ref={scrollerRef} className="ilp-api-track ilp-noscrollbar">
          {CARDS.map((card) => (
            <div key={card.name} className="ilp-api-card">
              <div className="ilp-api-card-art">
                <img src={card.image} alt={`${card.name} product card`} />
              </div>
              <p className="ilp-api-card-caption">{card.caption}</p>
            </div>
          ))}
        </div>

        <div className="ilp-api-promos">
          {PROMOS.map((promo) => (
            <button
              key={promo.title}
              type="button"
              className="ilp-api-promo"
              onClick={() => setSalesOpen(true)}
            >
              <img src={promo.accent} alt="" aria-hidden="true" className="ilp-api-promo-art" />
              <div className="ilp-api-promo-copy">
                <h3>{promo.title}</h3>
                <p>{promo.body}</p>
              </div>
              <span className="ilp-api-promo-link">
                {promo.linkLabel}
                <ArrowRight aria-hidden="true" />
              </span>
            </button>
          ))}
        </div>
      </div>

      <ContactSalesModal open={salesOpen} onOpenChange={setSalesOpen} />
    </section>
  );
};

export default ApiIntegration;
